import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, Modal, Button } from "react-bootstrap";
import ExportToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import SearchBar from "../../../../components/SearchBar";
import { useNavigate } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import moment from "moment";
import { useSelector } from "react-redux";
import { FaSpinner } from "react-icons/fa";

const JobOpeningComponent = ({
  data = [], // Set default value to an empty array if data is undefined or null
  columns,
  defaultColumns,
  // itemsPerPage,
  searchTerm,
  setSearchTerm,
  handleIcon1,
  handleIcon2,
  handleIcon3,
  handleIcon4,
  isApiStatus,
  handleIcon5,
  showIcon1,
  showIcon2,
  showIcon3,
  showIcon4,
  showIcon5,
  icons,
  addNewPath,
  handleShowModalInParent,
  modalData,
}) => {
  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const toggleColumn = (columnName) => {
    setVisibleColumns({
      ...visibleColumns,
      [columnName]: !visibleColumns[columnName],
    });
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const navigate = useNavigate();

  const handleEdit = (url, id) => {
    navigate(`${url}${id}`);
  };

  const handleSort = (columnName) => {
    let direction = "ascending";
    if (
      sortConfig &&
      sortConfig.key === columnName &&
      sortConfig.direction === "ascending"
    ) {
      direction = "descending";
    }
    setSortConfig({ key: columnName, direction });
  };


  const sortedData = useMemo(() => {
    if (!Array.isArray(data)) return []; // Ensure data is an array
    let sortableItems = [...data];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
        const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

        // Split the values into alphabetical and numeric parts
        const partsA = valA.match(/(\D+|\d+)/g) || [];
        const partsB = valB.match(/(\D+|\d+)/g) || [];

        for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
          const partA = partsA[i] || "";
          const partB = partsB[i] || "";

          // Determine if parts are numeric or alphabetical
          const isNumericA = !isNaN(partA);
          const isNumericB = !isNaN(partB);

          if (isNumericA && isNumericB) {
            // Both parts are numeric, so compare as numbers
            const numA = parseInt(partA, 10);
            const numB = parseInt(partB, 10);
            if (numA !== numB) {
              return sortConfig.direction === "ascending"
                ? numA - numB
                : numB - numA;
            }
          } else if (isNumericA || isNumericB) {
            // One part is numeric and the other is alphabetical
            return isNumericA ? -1 : 1;
          } else {
            // Both parts are alphabetical, so compare as strings
            if (partA !== partB) {
              return sortConfig.direction === "ascending"
                ? partA.localeCompare(partB)
                : partB.localeCompare(partA);
            }
          }
        }

        return 0;
      });
    }
    return sortableItems;
  }, [data, sortConfig]);

  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleAddNew = () => {
    navigate(addNewPath);
  };

  const handleShowModal = (content, id) => {
    setModalContent(content);
    setShowModal(true);
    handleShowModalInParent(id);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalContent(null);
  };

  const itemsPerPages = 5; // Adjust the number of items per page
  const [currentPages, setCurrentPages] = useState(1);

  const totalItems = modalData ? modalData.length : 0;

  const handlePageChanges = (pageNumber) => {
    setCurrentPages(pageNumber);
  };
  const ExcelName = useSelector(
    ({ layoutReducer }) => layoutReducer?.filterSlice?.navbarHeading
  );
  // Slice the data based on the current page and items per page
  const indexOfLastItem = currentPages * itemsPerPages;
  const indexOfFirstItem = indexOfLastItem - itemsPerPages;
  const currentItems = modalData?.slice(indexOfFirstItem, indexOfLastItem);

  const recordsPerPageOption = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
    { value: filteredData.length, label: 'All' },
  ];

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);

    // Calculate the new starting record index based on the current page
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;

    // Update state
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage); // Adjust to the new page based on the same starting record index
    setItemsPerPage(newRecordsPerPage);
  };
  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="me-1">
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        </div>

        <div className="d-flex justify-content-end">
       
        </div>
      </div>
      <div className="box-body table-responsive">
        <Table striped bordered hover>
          <thead id="thcolor" className="text-center">
            <tr>
              {Object.keys(columns).map(
                (columnName) =>
                  visibleColumns[columnName] && (
                    <th key={columnName} onClick={() => handleSort(columnName)}>
                      {columns[columnName].text}
                      <span className="ms-2">
                        {sortConfig.key === columnName ? (
                          sortConfig.direction === "ascending" ? (
                            <i className="bi bi-chevron-up"></i>
                          ) : (
                            <i className="bi bi-chevron-down"></i>
                          )
                        ) : (
                          <i className="bi bi-chevron-down"></i>
                        )}
                      </span>
                    </th>
                  )
              )}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
             {isApiStatus === 200 && currentData.length !== 0 ? (
  currentData.map((item, index) => (
    <tr key={index}>
      {Object.keys(columns).map((columnName) => {
        let cellValue = item[columnName];
        const isNumeric = typeof cellValue === "number";
        const isYesOrNo = cellValue === "Yes" || cellValue === "No";
        const isDateColumn = columns[columnName].text.toLowerCase().includes("date");
        const isActiveCol = columns[columnName].text === "Active";

        if (isActiveCol) {
          cellValue = cellValue === "Yes" ? "Yes" : "No";
        }

        if (columnName === "LeadCount") {
          return (
            visibleColumns[columnName] && (
              <td
                key={columnName}
                className="text-center"
                onClick={() => handleShowModal(item.LeaveCount, item.ID)}
                style={{ cursor: "pointer", color: "blue" }}
                text
              >
                {cellValue}
              </td>
            )
          );
        }

        if (columnName === "Title") {
          return (
            visibleColumns[columnName] && (
              <td key={columnName} className="text-start">
                {cellValue}
              </td>
            )
          );
        }

        return (
          visibleColumns[columnName] && (
            <td
              className={`${isNumeric ? "text-center me-3" : ""} ${
                isYesOrNo ? "text-center" : ""
              } ${isDateColumn ? "text-center" : ""}`}
              key={columnName}
            >
              {cellValue}
            </td>
          )
        );
      })}
      <td>
        <div className="d-flex justify-content-center">
          {showIcon1 && (
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="tooltip-bottom">View</Tooltip>}
            >
              <div className="me-2" onClick={() => handleIcon1(item)}>
                {icons.Icon1}
              </div>
            </OverlayTrigger>
          )}
          {showIcon2 && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                item.IsInActive === "Yes" ? (
                  <Tooltip id="tooltip-bottom">Refer Candidate</Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <div
                onClick={() => {
                  navigate('/refer-candidate/add', { state: item });
                }}
              >
                {icons.Icon2}
              </div>
            </OverlayTrigger>
          )}
          {showIcon3 && (
            <div className="me-2" onClick={() => handleIcon3(item)}>
              {icons.Icon3}
            </div>
          )}
          {showIcon4 && (
            <div className="me-2" onClick={() => handleIcon4(item)}>
              {icons.Icon4}
            </div>
          )}
          {showIcon5 && (
            <div className="me-2" onClick={() => handleIcon5(item)}>
              {icons.Icon5}
            </div>
          )}
        </div>
      </td>
    </tr>
  ))
) : isApiStatus === 200 && currentData.length === 0 ? (
  <tr>
    <td colSpan={Object.keys(columns).length + 1} className="text-center">No Data Found</td>
  </tr>
) : isApiStatus === undefined ? (
  <tr>
    <td colSpan={Object.keys(columns).length + 1} className="text-center">
      <FaSpinner className="spinner" />
    </td>
  </tr>
) : null}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(
                currentPage * selectedRecordsPerPage,
                filteredData.length
              )}{" "}
              of {filteredData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={itemsPerPage}
              totalItems={filteredData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        <Modal show={showModal} onHide={handleCloseModal} size="lg">
          <Modal.Header closeButton className="p-2">
            <Modal.Title>
              <b>Candidate Details</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table striped bordered hover>
              <thead id="thcolor" className="text-center">
                <tr>
                  <th>Candidate Name</th>
                  <th>Recruiter Name</th>
                  <th>Applied Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(currentItems) && currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.FullName}</td>
                      <td>{item.RecruiterName}</td>
                      <td>{moment(item.AppliedDate).format("DD-MMM-YYYY")}</td>
                      <td>{item.Status}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="d-flex justify-content-end">
              <Pagination
                itemsPerPage={itemsPerPages}
                totalItems={totalItems}
                currentPage={currentPages}
                onPageChange={handlePageChanges}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="custom-btn" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default JobOpeningComponent;
